import auth from '@/router/auth'
import TestKitIndex from '@/components/test-results-v2/Index'
import TestKitCreate from '@/components/test-results-v2/Create'
import TestKitUpdate from '@/components/test-results-v2/Update'
import TestKitShow from '@/components/test-results-v2/Show'

export default [
  {
    path: '/test-results-v2',
    name: 'test-results-v2-index',
    component: TestKitIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results-v2/create',
    name: 'test-results-v2-create',
    component: TestKitCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results-v2/update/:test_kit_id',
    name: 'test-results-v2-update',
    component: TestKitUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results-v2/show/:test_kit_id',
    name: 'test-results-v2-show',
    component: TestKitShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/test-results-v2/router.js